// Mock data for MTJ SECURITE PRIVÉE

export const companyInfo = {
  name: "MTJ SECURITE PRIVÉE",
  slogan: "VOTRE SÉCURITÉ, NOTRE MISSION.",
  motto: "Avec Force et Honneur Toujours servir",
  phone: "07 60 73 82 06",
  email: "contactsmtjsecuriteprivee@gmail.com",
  address: "31 rue Chevalier Paul, 83200 Toulon",
};

export const aboutUs = {
  title: "QUI SOMMES NOUS",
  description: `MTJ SÉCURITÉ PRIVÉE est une entreprise spécialisée dans la sécurité privée et la protection des biens et des personnes. 

Forte d'une équipe d'experts qualifiés et expérimentés, nous mettons notre savoir-faire au service de nos clients pour garantir leur tranquillité d'esprit.

Notre engagement se traduit par des interventions professionnelles, un respect strict des réglementations en vigueur et une disponibilité 24h/24 et 7j/7.

Nous sommes fiers de notre expertise en sécurité cynophile, avec des maîtres-chiens formés aux techniques les plus avancées de surveillance et de détection.`,
};

export const services = [
  {
    id: 1,
    title: "AGENTS DE PRÉVENTION ET SÉCURITÉ",
    description: "Nos agents de prévention et de sécurité assurent la surveillance et la protection de vos sites. Formés aux dernières techniques de sécurité, ils garantissent un environnement sûr pour vos activités professionnelles et personnelles.",
    icon: "Shield",
    link: "/agent-securite-prevention",
    color: "#AC8631",
    features: [
      "Surveillance de sites",
      "Contrôle d'accès",
      "Rondes de sécurité",
      "Gestion des alarmes"
    ]
  },
  {
    id: 2,
    title: "AGENTS CYNOPHILE D'INTERVENTION",
    description: "Notre équipe cyno d'intervention est spécialisée dans la sécurité avec chiens d'intervention. Nos binômes maître-chien sont formés pour intervenir rapidement et efficacement dans toutes les situations nécessitant une sécurité renforcée.",
    icon: "Dog",
    link: "/securite-cynophile-maitre-chien",
    color: "#AC8631",
    features: [
      "Surveillance avec chiens d'intervention",
      "Intervention rapide",
      "Sécurité événementielle",
      "Patrouilles cynophiles"
    ]
  },
  {
    id: 3,
    title: "CYNODEX",
    subtitle: "Détection d'Explosifs",
    description: "Notre unité CYNODEX est spécialisée dans la détection d'explosifs avec des chiens hautement entraînés. Nos équipes certifiées garantissent la sécurité de vos événements et installations.",
    icon: "Dog",
    link: "/detection-explosifs-cynodex",
    color: "#AC8631",
    features: [
      "Détection d'explosifs",
      "Sécurisation d'événements",
      "Inspection de sites sensibles",
      "Intervention préventive"
    ]
  },
  {
    id: 4,
    title: "SSIAP",
    subtitle: "Service de Sécurité Incendie et d'Assistance à Personnes",
    description: "Nos agents SSIAP certifiés assurent la sécurité incendie de vos établissements recevant du public. Ils garantissent le respect des normes de sécurité et la protection des personnes.",
    icon: "Flame",
    link: "/ssiap-securite-incendie",
    color: "#B00B0B",
    features: [
      "Prévention incendie",
      "Évacuation d'urgence",
      "Gestion des équipements de sécurité"
    ]
  },
  {
    id: 5,
    title: "PROTECTION PHYSIQUE DES PERSONNES",
    subtitle: "Sécurité Rapprochée",
    description: "La protection rapprochée de personnalités, dirigeants d'entreprise, célébrités et particuliers exposés. Des agents de protection rapprochée, formés aux techniques d'évaluation des menaces, d'escorte et de sécurisation de déplacements, garantissent votre intégrité physique en toute discrétion.",
    legalNotice: "AUT-006-2123-10-21-20240955994\nL612-14 du CSI L'autorisation administrative préalable ne confère aucun caractère officiel à l'entreprise ou aux personnes qui en bénéficient. Elle n'engage en aucune manière la responsabilité des pouvoirs publics.",
    icon: "UserShield",
    features: [],
    wide: true,
    externalCompany: "MTJ SÉCURITÉ RAPPROCHÉE",
    link: "/protection-rapprochee",
    color: "#68187B"
  }
];

export const interventionDomains = {
  title: "DOMAINE D'INTERVENTION",
  description: "MTJ SÉCURITÉ PRIVÉE intervient dans de nombreux secteurs d'activité pour répondre à tous vos besoins en matière de sécurité.",
  domains: [
    {
      id: 1,
      name: "Événementiel",
      description: "Sécurisation de concerts, festivals, événements sportifs et manifestations culturelles",
      link: "/securite-evenementielle"
    },
    {
      id: 2,
      name: "Sites industriels et commerciaux",
      description: "Protection des zones industrielles, entrepôts, centres commerciaux et espaces professionnels",
      link: "/securite-sites-industriels-commerciaux"
    },
    {
      id: 3,
      name: "Chantiers",
      description: "Surveillance de chantiers, prévention du vol de matériel et sécurisation des zones de construction",
      link: "/surveillance-chantier-site"
    },
    {
      id: 4,
      name: "Résidentiel",
      description: "Sécurité des résidences privées, copropriétés et domaines",
      link: "/securite-residentielle"
    },
    {
      id: 5,
      name: "Établissements recevant du public",
      description: "Protection des ERP, contrôle d'accès et gestion des flux",
      link: "/securite-erp-etablissements-public"
    }
  ]
};

export const quoteForm = {
  title: "DEVIS",
  subtitle: "Demandez votre devis personnalisé",
  description: "Remplissez le formulaire ci-dessous et notre équipe vous contactera dans les plus brefs délais pour établir un devis adapté à vos besoins.",
};

export const contactInfo = {
  title: "CONTACT",
  subtitle: "Contactez-nous",
  description: "Notre équipe est à votre disposition pour répondre à toutes vos questions et vous accompagner dans vos projets de sécurité.",
};
